export const STORAGE_KEY_MULTISELECTION = "storage-key-multiselection";
export const STORAGE_KEY_SHOWUNDEFINED = "storage-key-showundefined";
export const STORAGE_KEY_SATELLITEVIEW = "storage-key-satelliteview";
export const STORAGE_KEY_ENABLERESULTMOD = "storage-key-enableresultmod";
export const STORAGE_KEY_FILLUPRESULTS = "storage-key-fillupresults";
export const STORAGE_KEY_PLANT_VIEW_PANE_VERTICAL = "plant-view-storage-pane-vertical-view";
export const STORAGE_KEY_MAPFEATURE_POPUP_TABINDEX = "storage-key-mapfeature-popup-tabindex";
export const STORAGE_KEY_OMO_TOKEN_PREFIX = "storage-key-omo-token-";
export const STORAGE_KEY_AUTH_TOKEN = "auth_token"
// Admin-only customer filter, shared by the plants and analyses overview pages
export const STORAGE_KEY_SELECTED_CUSTOMER_FILTER = "app-overview:selectedCustomerFilter";
// Step statuses the monitoring page's config manager hides
export const STORAGE_KEY_CONFIG_MANAGER_HIDDEN_STATUSES = "app-monitoring:configManagerHiddenStatuses";
// v2: the settings without mode and curve; older ones are ignored
export const STORAGE_KEY_IR_DISPLAY_PREFIX = "storage-key-ir-display-v2-";
